<template>
  <footer class="aura-footer">
    <div class="footer-top">
      <div class="footer-grid">
        <!-- Brand column -->
        <div class="footer-col footer-brand-col">
          <img src="img/logo-white-1x.png" alt="Star Jasmine" class="footer-logo" />
          <p class="footer-tagline">
            {{ $t('ourMissionDesc') }}
          </p>
          <div class="footer-socials">
            <a href="https://wa.me/85253425261" target="_blank" title="WhatsApp" class="social-link">
              <span class="ti-comment"></span>
            </a>
            <a href="https://www.facebook.com/%E6%98%9F%E7%A9%BA%E5%83%B1%E5%82%AD%E4%B8%AD%E5%BF%83-Star-Jasmine-Employment-Centre-102117558909715" target="_blank" title="Facebook" class="social-link">
              <span class="ti-facebook"></span>
            </a>
            <a href="https://www.instagram.com/star_jasmine_employment_centre/" target="_blank" title="Instagram" class="social-link">
              <span class="ti-instagram"></span>
            </a>
          </div>
        </div>

        <!-- Links column -->
        <div class="footer-col">
          <h5 class="footer-col-title">{{ $t('OthersLinks') }}</h5>
          <ul class="footer-links">
            <li><router-link to="/">{{ $t('home') }}</router-link></li>
            <li><router-link to="/about">{{ $t('AboutUs') }}</router-link></li>
            <li><router-link to="/services">{{ $t('OurServices') }}</router-link></li>
            <li><router-link to="/join">{{ $t('JoinUs') }}</router-link></li>
            <li><router-link to="/contact">{{ $t('ContactUs') }}</router-link></li>
            <li><router-link to="/matching" class="footer-link-highlight">{{ $t('Matching') }}</router-link></li>
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
          </ul>
        </div>

        <!-- Contact column -->
        <div class="footer-col">
          <h5 class="footer-col-title">{{ $t('ContactUs') }}</h5>
          <ul class="footer-contact-list">
            <li>
              <a href="https://www.google.com/maps/place/Whampoa+108" target="_blank">
                <span class="ti-location-pin"></span>
                <span>{{ $t('address2') }}, {{ $t('address') }}</span>
              </a>
            </li>
            <li>
              <a href="tel:+25599223">
                <span class="ti-mobile"></span>
                <span>{{ $t('tel') }}: 2559 9223</span>
              </a>
            </li>
            <li>
              <a href="https://wa.me/85253425261">
                <span class="ti-comment-alt"></span>
                <span>WhatsApp: 5342 5261</span>
              </a>
            </li>
            <li>
              <a href="mailto:cs@hkhomeservices.com.hk">
                <span class="ti-email"></span>
                <span>cs@hkhomeservices.com.hk</span>
              </a>
            </li>
            <li>
              <span class="ti-id-badge"></span>
              <span>Licence No. 81643</span>
            </li>
          </ul>
        </div>

        <!-- Map column -->
        <div class="footer-col footer-map-col">
          <h5 class="footer-col-title">{{ $t('Location') }}</h5>
          <div class="footer-map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d230.70223768530886!2d114.1880394986012!3d22.306920125971676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400de2501be6d%3A0xba9a2779dff22d46!2sWhampoa%20108!5e0!3m2!1sen!2sus!4v1715742327660!5m2!1sen!2sus"
              width="100%"
              height="200"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>Copyrights © 2021 All rights reserved by Hong Kong Home Services Centre</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
.aura-footer {
  background: #0A7A76;
  color: #94a3b8;
  font-family: 'Montserrat', sans-serif;
}

/* ── Top section ── */
.footer-top {
  max-width: 1280px;
  margin: 0 auto;
  padding: 72px 48px 56px;
}
.footer-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.2fr 1.4fr;
  gap: 48px;
}

/* ── Brand ── */
.footer-logo {
  width: 264px;
  margin-bottom: 20px;
  display: block;
  opacity: 0.9;
}
.footer-tagline {
  font-size: 13px;
  line-height: 1.75;
  color: rgba(255,255,255,0.65);
  margin: 0 0 24px;
  max-width: 260px;
}
.footer-socials {
  display: flex;
  gap: 10px;
}
.social-link {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.8) !important;
  font-size: 14px;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  text-decoration: none !important;
}
.social-link:hover {
  background: #F5A340;
  color: #fff !important;
  border-color: #F5A340;
}

/* ── Column titles ── */
.footer-col-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #e2e8f0;
  margin: 0 0 20px;
}

/* ── Nav links ── */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer-links a {
  font-size: 14px;
  color: rgba(255,255,255,0.65) !important;
  text-decoration: none !important;
  transition: color 0.2s;
}
.footer-links a:hover { color: #ffffff !important; }
.footer-link-highlight {
  color: #F5A340 !important;
}
.footer-link-highlight:hover { color: #F7B95A !important; }

/* ── Contact list ── */
.footer-contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.footer-contact-list li,
.footer-contact-list a {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: rgba(255,255,255,0.65) !important;
  text-decoration: none !important;
  line-height: 1.5;
  transition: color 0.2s;
}
.footer-contact-list a:hover { color: #ffffff !important; }
.footer-contact-list span[class^="ti-"] {
  margin-top: 2px;
  font-size: 14px;
  flex-shrink: 0;
  color: rgba(255,255,255,0.45);
}

/* ── Map ── */
.footer-map-wrap {
  border-radius: 14px;
  overflow: hidden;
  opacity: 0.8;
}
.footer-map-wrap iframe {
  display: block;
}

/* ── Bottom bar ── */
.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.07);
  padding: 20px 48px;
  max-width: 1280px;
  margin: 0 auto;
}
.footer-bottom p {
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  text-align: center;
  margin: 0;
}

/* ── Responsive ── */
@media (max-width: 1024px) {
  .footer-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 640px) {
  .footer-top { padding: 48px 24px 40px; }
  .footer-grid { grid-template-columns: 1fr; gap: 36px; }
  .footer-bottom { padding: 16px 24px; }
}
</style>
